import React from 'react'

import { Heading, ScrollList, theme } from '@hhgtech/hhg-components'
import Link from 'next/link'

import { Container } from 'components/atoms/container'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { Article } from 'interfaces/types'

import {
  StyledGeneralDesktopContainer,
  StyledFeatureSmallArticleContainer,
  StyledTitleContainer,
  StyledArticleDesktopContainer,
} from './index.styled'

export type Props = {
  posts: Article[]
  isMobile: boolean
  title: string
  viewType: string
  columns?: number
}
const InformationSection = ({
  posts,
  isMobile,
  title,
  viewType,
  columns,
}: Props) => {
  const { locale } = useRouterExtend()

  return (
    <div data-name={title}>
      <Container
        style={{
          backgroundColor: theme.colors.white,
          marginTop: 0,
          marginBottom: isMobile ? 48 : 64,
        }}
      >
        <StyledTitleContainer>
          <Heading tag="h3">{title}</Heading>
        </StyledTitleContainer>
        <StyledGeneralDesktopContainer data-view-type={viewType}>
          {posts.map((article: Article, id) => (
            <React.Fragment key={id}>
              {viewType === 'list' && (
                <StyledFeatureSmallArticleContainer>
                  <Link
                    prefetch={false}
                    href={article.permalink}
                    style={{ textDecoration: 'none' }}
                    legacyBehavior
                  >
                    <ArticleCardWrapper
                      article={article}
                      dataEventCategoryForCategory="Spotlight"
                      dataEventActionForCategory={`List Click ${id + 1}`}
                      dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                      dataEventCategoryForTitle="Spotlight"
                      dataEventActionForTitle={`List Click ${id + 1}`}
                      dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      dataEventCategoryForBanner="Spotlight"
                      dataEventActionForBanner={`List Click ${id + 1}`}
                      dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      isMobile={isMobile}
                      type="author"
                      size={isMobile ? 'sm' : 'md'}
                      direction="horizontal"
                    />
                  </Link>
                </StyledFeatureSmallArticleContainer>
              )}
              {!isMobile && viewType === 'gird' && (
                <StyledArticleDesktopContainer data-columns={columns}>
                  <ArticleCardWrapper
                    article={article}
                    dataEventCategoryForTitle="Top Article Title"
                    dataEventActionForTitle={`Click ${id + 2}`}
                    dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    dataEventCategoryForCategory="Top Category Title"
                    dataEventActionForCategory={`Click ${id + 2}`}
                    dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                    dataEventCategoryForBanner="Top Article Banner"
                    dataEventActionForBanner={`Click ${id + 2}`}
                    dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    type="author"
                    size="sm"
                    direction="vertical"
                    bannerImageWrapProps={
                      {
                        'data-event-category': 'Top Article Banner',
                        'data-event-action': `Click ${id + 2}`,
                        'data-event-label': `https://${domainLocales[locale]}${article.permalinkDecode}`,
                      } as any
                    }
                    text=""
                  />
                </StyledArticleDesktopContainer>
              )}
            </React.Fragment>
          ))}
          {isMobile && viewType === 'gird' && (
            <ScrollList
              className="gird-view"
              column={1}
              distanceOverlappedLeft={{
                amount: 0,
                unit: 'percentage',
              }}
              isDotsShown={false}
              mode="infinity"
              row={1}
              type="intertwined"
              page={0}
            >
              {posts.map((article: Article, id) => (
                <StyledArticleDesktopContainer key={id} data-columns={columns}>
                  <ArticleCardWrapper
                    article={article}
                    dataEventCategoryForTitle="Top Article Title"
                    dataEventActionForTitle={`Click ${id + 2}`}
                    dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    dataEventCategoryForCategory="Top Category Title"
                    dataEventActionForCategory={`Click ${id + 2}`}
                    dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                    dataEventCategoryForBanner="Top Article Banner"
                    dataEventActionForBanner={`Click ${id + 2}`}
                    dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    type="author"
                    size="sm"
                    direction="vertical"
                    bannerImageWrapProps={
                      {
                        'data-event-category': 'Top Article Banner',
                        'data-event-action': `Click ${id + 2}`,
                        'data-event-label': `https://${domainLocales[locale]}${article.permalinkDecode}`,
                      } as any
                    }
                    text=""
                  />
                </StyledArticleDesktopContainer>
              ))}
            </ScrollList>
          )}
        </StyledGeneralDesktopContainer>
      </Container>
    </div>
  )
}

export { InformationSection }
